// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ProviderLinesController from "./provider_lines_controller"
application.register("provider-lines", ProviderLinesController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import HorizontalScrollController from "./horizontal_scroll_controller"
application.register("horizontal-scroll", HorizontalScrollController)

import StaffShiftDurationController from "./staff_shift_duration_controller"
application.register("staff-shift-duration", StaffShiftDurationController)
